// Matches backend enums and DTOs

export enum EpubRendererType {
  CustomHtml = 1,
  EpubJs = 2,
}

export enum BookStatus {
  Draft = 1,
  Published = 2,
  Archived = 3,
}

export enum BookFormat {
  Epub = 1,
  Pdf = 2,
}

export interface BookDto {
  id: string;
  title: string;
  author: string;
  isbn: string;
  edition?: string;
  language?: string;
  format: BookFormat;
  fileSize: number;
  pageCount?: number;
  coverImageUrl?: string;
  description?: string;
  publishedDate?: string;
  status: BookStatus;
  rendererType: EpubRendererType;
  complexityScore: number;
  complexityDetails?: string;
  subjects?: string;
  contributors?: string;
  rights?: string;
  publisherId: string;
  isDrmEnabled: boolean;
  isDeleted?: boolean;
  defaultPrintQuotaLimit?: number | null;
  defaultPrintQuotaWindowDays?: number | null;
  defaultCopyQuotaLimit?: number | null;
  defaultCopyQuotaWindowDays?: number | null;
  defaultDownloadQuotaLimit?: number | null;
  defaultDownloadQuotaWindowDays?: number | null;
  concurrencyStamp: string;
  creationTime?: string;
}

export interface ChapterInfoDto {
  index: number;
  title: string;
}

export interface BookMetadataDto {
  id: string;
  title: string;
  author: string;
  isbn?: string;
  coverImageUrl?: string;
  format: BookFormat;
  rendererType: EpubRendererType;
  pageCount?: number;
  chapters: ChapterInfoDto[];
  isDrmEnabled: boolean;
}

export interface ChapterContentDto {
  htmlContent: string;
  chapterTitle: string;
  totalChapters: number;
  currentChapterIndex: number;
}

export interface GetChapterContentInput {
  bookId: string;
  chapterIndex: number;
}

export interface BookUploadDto {
  title: string;
  author: string;
  isbn: string;
  edition?: string;
  language?: string;
  format: BookFormat;
  pageCount?: number;
  coverImageUrl?: string;
  description?: string;
  publishedDate?: string;
  publisherId: string;
  // DRM Quota Defaults (optional - inherits from publisher if not set)
  defaultPrintQuotaLimit?: number | null;
  defaultPrintQuotaWindowDays?: number | null;
  defaultCopyQuotaLimit?: number | null;
  defaultCopyQuotaWindowDays?: number | null;
  defaultDownloadQuotaLimit?: number | null;
  defaultDownloadQuotaWindowDays?: number | null;
}

/**
 * Result from async book upload
 * Returned immediately with a tracking ID for polling
 */
export interface BookUploadResultDto {
  trackingId: string;
  status: string;
  message: string;
}

/**
 * Upload status for async book processing
 * Retrieved by polling with tracking ID
 */
export interface BookUploadStatusDto {
  trackingId: string;
  status: 'Queued' | 'Processing' | 'Success' | 'Failed';
  fileName?: string;
  title?: string;
  bookId?: string;
  errorMessage?: string;
  errorCode?: string;
  queuedAt?: string;
  processingTimeSeconds?: number;
}
